export default __webpack_public_path__ + "static/media/(8).2c19c35b.jpg";